import { render, staticRenderFns } from "./PlayerStandardInfoPage.vue?vue&type=template&id=50696e2a&scoped=true&"
import script from "./PlayerStandardInfoPage.vue?vue&type=script&lang=js&"
export * from "./PlayerStandardInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./PlayerStandardInfoPage.vue?vue&type=style&index=0&id=50696e2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50696e2a",
  null
  
)

export default component.exports